import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.modalModel ? _c(VDialog, {
    key: "multiple",
    staticClass: "tw-relative",
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: _vm.modalModel,
      callback: function ($$v) {
        _vm.modalModel = $$v;
      },
      expression: "modalModel"
    }
  }, [_c(VCard, {
    attrs: {
      "outlined": _vm.$vuetify.theme.dark
    }
  }, [_c(VToolbar, [_c(VBtn, {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c(VIcon, [_vm._v("mdi-close")])], 1), _c(VToolbarTitle, [_vm._v(_vm._s(_vm.$t('components.multiple_upload.library')))]), _c(VSpacer), _c(VToolbarItems, [_c(VBtn, {
    attrs: {
      "loading": _vm.uploading
    },
    on: {
      "click": _vm.openUploadPanel
    }
  }, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cloud-upload")]), _vm._v(" " + _vm._s(_vm.$t('components.multiple_upload.upload_files')) + " ")], 1)], 1)], 1), _c('Library', {
    ref: "library",
    attrs: {
      "data": _vm.data
    },
    model: {
      value: _vm.dataModel,
      callback: function ($$v) {
        _vm.dataModel = $$v;
      },
      expression: "dataModel"
    }
  }), _c('input', {
    staticClass: "tw-hidden",
    attrs: {
      "id": "multi-media-dialog-input",
      "multiple": "",
      "name": "",
      "type": "file"
    },
    on: {
      "change": _vm.uploadMedia
    }
  })], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };